// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"720":"dateTime","985":"tour"}[chunkId] || chunkId) + ".chunk-" + __webpack_require__.h() + ".js";
};